import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom"; 
import config from '../../config';

function PortfolioList() {
    const [portfolios, setPortfolios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchPortfolios = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-portfolios`, { withCredentials: true });
            
            if(response.data){
                setPortfolios(response.data);
            }

        } catch (err) {
            setError('Failed to fetch portfolios');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPortfolios();
    }, []);

    return (
        <>
            <div className="dashboard">
                <div className="container">
                    <h1 className="dash_title">Portfolios</h1>
                    <div className="main-section">
                        <div className="projects">
                            <div className="projects-inner">
                                <header className="projects-header">
                                    <div className="title">
                                        Total 
                                        <div className="count"> {portfolios.length } portfolios</div>
                                    </div>
                                    <div className="project_search">
                                        {/* <form action="">
                                            <input type="text" name="search" placeholder="Search blogs" />
                                            <button type="submit" className="btn">Search</button>
                                        </form> */}
                                    </div>
                                    <div className="add_project">
                                        <Link to="/admin/add-portfolio">Add Portfolio</Link>
                                    </div>
                                </header>
                                <table className="projects-table">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Location</th>
                                            <th className="text-right">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="4">Loading...</td>
                                            </tr>
                                        ) : error ? (
                                            <tr>
                                                <td colSpan="4">{error}</td>
                                            </tr>
                                        ) : (
                                            portfolios.map((portfolio, index) => ( 
                                                <tr key={portfolio._id}>
                                                    <td><p>{portfolio.title}</p></td>
                                                    <td><p>{portfolio?.location}</p></td>
                                                    <td>
                                                        <Link to={`/admin/portfolio/${portfolio._id}`} className="view_detail">View Details</Link>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PortfolioList;
